import React, { Component } from 'react';
import AriaModal from 'react-aria-modal';
import {actions} from 'mirrorx';

import './modal.css';
class OverwriteFileModal extends Component {

	constructor() {
		super();

		this.state = {
			showModal: false
		}

		this.activateModal = this.activateModal.bind(this);
		this.deactivateModal = this.deactivateModal.bind(this);
		this.confirmModal = this.confirmModal.bind(this);
	}

	deactivateModal() {
		this.setState({
			showModal: false
		})
	}
	confirmModal() {
		this.setState({
			showModal: false
		});

		const data = {
			name: this.props.name,
			path: this.props.path,
			service: this.props.service
		};

		actions.editor.updateFileMetadata(data)

		if (this.props.onClick) {
			this.props.onClick(data);
		}
	}
	activateModal() {
		this.setState({
			showModal: true
		});
	}

	_renderModal() {
		return <AriaModal
          titleText="Overwrite File"
          onExit={this.deactivateModal}
          underlayStyle={{ paddingTop: '2em' }}
        >
          <div className="modal">
            <div className="modal-body">
            	<p>{this.props.customText ? this.props.customText : 
            		'Overwrite file at ' + this.props.path + this.props.name+'?'}</p>
            </div>
            <footer className="modal-footer">
              <button className='btn' onClick={this.deactivateModal}>
                No
              </button>
              <button className='btn' onClick={this.confirmModal}>
                Yes
              </button>
            </footer>
          </div>
        </AriaModal>
	}

	render() {
		return <div>{this.state.showModal ? this._renderModal() : null}</div>
	}
}

export default OverwriteFileModal;


// WEBPACK FOOTER //
// ./src/components/overwrite-file-modal.js